<template>
  <div class="sorting-btn">
    <button type="button" class="sorting-btn-all" @click.prevent="toggleSelectBox">
      <SortIcon/>
      <span class="sorting-filter-hd">{{filterText}}</span>
      <span>
          <IconDown v-if="!toggleSelect"/>
          <IconUp v-if="toggleSelect"/>
        </span>
    </button>
    <ul class="sorting-list" v-if="toggleSelect">
      <li v-for="(filterItem, index) in filteredFilterList" :key="'filter_' + index">
        <button type="button" :data-src="filterItem.id" @click.prevent="()=>setFilter(filterItem)">
          {{filterItem.text}}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import SortIcon from '@/assets/svg/common/ic-sort.svg'
import IconDown from '@/assets/svg/common/ic-down-p.svg'
import IconUp from '@/assets/svg/common/ic-up-p.svg'
export default {
  name: 'FaqFilterList',
  components: {
    SortIcon,
    IconDown,
    IconUp
  },
  props: {
    filteredFilterList: {
      type: Array
    },
    toggleSelectBoxFn: {
      type: Function
    },
    setFilterFn: {
      type: Function
    },
    filterText: {
      type: String
    },
    toggleSelect: {
      type: Boolean
    }
  },
  methods: {
    toggleSelectBox () {
      this.toggleSelectBoxFn()
    },
    setFilter (filterItem) {
      this.setFilterFn(filterItem)
    }
  }
}
</script>
